import React from 'react';
import { EarIcon, RadioTowerIcon } from 'lucide-react';
import type { StoryLine } from '../../types/demo';
import { AMARA_TEEN } from '../../data/speakers';
interface DialogueCardProps {
  line: StoryLine;
}
export function DialogueCard({
  line
}: DialogueCardProps) {
  switch (line.kind) {
    case 'sound':
      return <p className="flex items-start gap-2 rounded-xl bg-sand px-4 py-2 text-ink" data-id="element-526" data-mp="1qvhb6ii8vpzt">
          <EarIcon size={20} className="mt-1 shrink-0 text-teal" aria-hidden="true" data-id="element-527" data-mp="135n0o7leediq" />
          <span data-id="element-528" data-mp="y6aelp2cpah7">
            <span className="sr-only" data-id="element-529" data-mp="y6k3f9bntblb">Sound cue: </span>[{line.text}]
          </span>
        </p>;
    case 'inner':
      return <div className="border-l-4 border-gold pl-4" data-id="element-530" data-mp="1c373hkywshvg">
          <p className="text-sm font-bold text-teal" data-id="element-531" data-mp="1755kf01hgijz">{line.speaker ?? AMARA_TEEN} thinks</p>
          <p className="italic text-ink" data-id="element-532" data-mp="2njnmfo9o9gn2">{line.text}</p>
        </div>;
    case 'speech':
      return <div className="rounded-2xl border border-line bg-paper px-4 py-3 hc-strong" data-id="element-533" data-mp="2ikc62gd7wd60">
          <p className="text-sm font-bold text-teal" data-id="element-534" data-mp="2ngsguz9nd8rd">{line.speaker}</p>
          <p className="text-ink" data-id="element-535" data-mp="2rhm8o3q7n7pj">“{line.text}”</p>
        </div>;
    case 'system':
      return <p className="flex items-center gap-2 rounded-xl bg-forest px-4 py-3 font-mono text-sm font-bold tracking-wide text-gold" data-id="element-536" data-mp="2wgyseflsbynw">
          <RadioTowerIcon size={18} aria-hidden="true" data-id="element-537" data-mp="31eqrbtkukl1l" />
          {line.text}
        </p>;
    default:
      return <p className="text-ink" data-id="element-538" data-mp="23tmib4wt9jbh">{line.text}</p>;
  }
}